export const ROUTES = {
    ROOT: () => `/`,
    ANNOUNCEMENT: (id: number | string = ':id') => `/announcements/${id}`,
    ANNOUNCEMENTS: () => `/announcements`,
    ARTICLE: (id: number | string = ':id') => `/articles/${id}`,
    ARTICLES: () => `/articles`,
    BOOKS: (id?: number) => (id ? `/books?id=${id}` : `/books`),
    CAFE: () => `/cafe`,
    CALENDAR: (params = '') => `/calendar${params}`,
    CHAT: (id: number | string = ':id') => `/chat/${id}`,
    CHATS: () => `/chat`,
    COMPANY: () => `/company`,
    COMPANY_STRUCTURE: () => `/company-structure`,
    DEPARTMENT: (id: number | string = ':departmentId') => `/department/${id}`,
    DEPARTMENT_BRANCH: (id: number | string = ':departmentBranchId') => `/department-branch/${id}`,
    DOCUMENTS: () => `/documents`,
    DOCUMENT_CATEGORIES: () => `/document-categories`,
    DOCUMENT_CATEGORY: (id: number | string = ':id') => `/document-category/${id}`,
    EDUCATION: () => `/education`,
    EDUCATION_LESSONS: (params = '') => `/education-lessons${params}`,
    ENTRY_PASSES: (withCreating = false) => withCreating ? `/entry-passes?create=1` : `/entry-passes`,
    ESSENTIAL: (id: number | string = ':id') => `/essentials/${id}`,
    ESSENTIALS: () => `/essentials`,
    FAQ: () => `/faq`,
    GALLERY: (id: number | string = ':id') => `/gallery/${id}`,
    HISTORY: () => `/history`,
    HOME: () => `/home`,
    IN_DEVELOPMENT: () => `/in-development`,
    ISPRING_COURSES: () => `/ispring/courses`,
    LIBRARY: () => `/library`,
    LIFE: () => `/life`,
    LOGIN: () => `/login`,
    NEWS: (id: number | string = ':id') => `/news/${id}`,
    NOTIFICATIONS: () => `/notifications`,
    OFFICES: () => `/offices`,
    PROFILE: () => `/profile`,
    PROFILE_DASHBOARD: () => `/profile/dashboard`,
    PROFILE_REPORTS: () => `/profile/reports`,
    REQUESTS: () => `/requests`,
    RESERVATIONS: () => `/reservations`,
    SEARCH: (params = '') => `/search${params}`,
    SURVEY: (id: number | string = ':id') => `/survey/${id}`,
    SURVEYS: () => `/surveys`,
    TASK_TRACKER: (id: number | string | null = ':id') => `/task-tracker/${id}`,
    TASK_TRACKER_ARCHIVE: () => `/task-tracker-archive`,
    TASK_TRACKER_TASK: (id: number | string | null = ':id') => `/task-tracker/personal?&taskTrackerTaskId=${id}`,
    TEST: () => `/test`,
    TEST_ID: (id: number | string = ':id') => `/test/${id}`,
    USER: (id: string | number | null = ':id') => `/user/${id}`,
    VACANCIES: () => `/vacancies`,
    VACANCY: (id: number | string = ':id') => `/vacancies/${id}`,
    VALUES: () => `/values`,

    PROFILE_DASHBOARD_DESIGNER: () => `/profile/dashboard/designer`,
    PROFILE_DASHBOARD_CONSULTANT: () => `/profile/dashboard/consultant`,
    PROFILE_DASHBOARD_MANAGER: () => `/profile/dashboard/manager`,
    PROFILE_DASHBOARD_TERRITORIAL: () => `/profile/dashboard/territorial`,
    PROFILE_DASHBOARD_TEST: () => `/profile/dashboard/test`,
};
